import { useMediaQuery } from './use-media-query'

// Tailwind `md`. Below this the docked right-edge surfaces (companion drawer,
// config rail) have no room and their hosts fall back to full-width sheets.
const DESKTOP_QUERY = '(min-width: 768px)'

export function useIsDesktop(): boolean {
  return useMediaQuery(DESKTOP_QUERY)
}
